import React, { Component } from 'react';
import queryString from 'query-string';
import { API_URL, REACT_APP_API_BASE } from '../config';
import withFetch from './withFetch';

const Container = (WrappedComponent, 
                autoCompletePath = '/api/v1/search/autocomplete',
                summaryHits = hits => hits,
                currentIndexItem = (item, currentValue) => item,
                defaultIndex = -1) => {
  class Container extends Component {
    constructor(props) {
      super(props);

      this.timer = null;
      this.wrapperRef = React.createRef();
      this.boundHandleClickOutside = this.handleClickOutside.bind(this);
      const query = queryString.parse(this.props.location.search);

      //Set initial state
      this.state = {
        isLoading: false,
        isVisible: false,
        categories: null,
        isLoadingCategories: true,
        index: defaultIndex,
        hits: [],
        value: query.searchText ? query.searchText : ''
      };
    }

    dispatch(action) {
        this.setState(action);
    }

    getState() {
      return this.state;
    }

    hasHits(hits) {
      return this.state.hits && this.state.length > 0;
    }

    handleKeyboard(e) {

      if (!this.state.hits || this.state.hits.length === 0) return;
      
      if (e.keyCode === 13) {
        if (this.state.index < 0) return;
        this.dispatch({
          isVisible: false
        });

        if (this.state.hits[this.state.index] && this.state.hits[this.state.index].unitId) {
          e.preventDefault();
          window.location.href = `/unit/${this.state.hits[this.state.index].unitId}`;
          return;
        }
      }

      if (e.keyCode === 38) {
        e.preventDefault();
        if (this.state.index < 0) {

          this.dispatch({
            index: this.state.hits.length-1,
            value: this.state.hits[this.state.hits.length-1].label
          });
          return;
        }

        const indexMinus = this.state.index - 1;
        this.dispatch({
          index: indexMinus,
          value: this.state.index < 0 ? this.state.defaultValue : this.state.hits[indexMinus].label
        });

      }

      if (e.keyCode === 40) {
        e.preventDefault();
        if (this.state.index >= this.state.hits.length-1) {
          this.dispatch({
            index: -1,
            value: this.state.defaultValue
          });

          return;
        }
        
        const indexPlus = this.state.index + 1;
        this.dispatch({
          index: indexPlus,
          value: this.state.hits[indexPlus].label
        });
      }

      if (e.keyCode === 27) {
        this.dispatch({
          isVisible: false
        });
        return;
      }
      return;
    }

    handleChange(e, forceSearch = false) {
      e.persist();
      const value = e.target.value;

      if (forceSearch || (value !== this.state.value && value.length > 1)) {
        clearTimeout(this.timer);
        this.timer = setTimeout(async () => {
            this.dispatch({
                ...this.getState(),
                isLoading: true
            });

            const query = API_URL('/units/suggest/', `searchText=${encodeURI(value)}`);
            await this.props.fetch(query).then(res => {
                
                const qs = queryString.parse(res.url.substring(res.url.indexOf('?')));
      
                if (qs.searchText === this.getState().value) {
                    if (res.headers.get('content-length') > 0) {
                        return res.json();
                    } else {
                        return [];
                    }
                    
                }
                
                return { aborted: true, valueReq: qs.searchText, valueState: this.getState().value }; 
            }).then(payload => {
                //Only dispatch response from the last request
                //TODO: When better browsersupport for fetch: abort request instead
                if (payload && payload.aborted) return;

                return this.dispatch({
                    key: query,
                    defaultValue: value,
                    hits: payload && payload.data ? payload.data : [],
                    isVisible: payload !== null,
                    isLoading: false
                });
            }); 
        }, 300);
      }
      
      this.dispatch({
        value: value,
        hits: value && value.length > 1 ? this.state.hits : [],
        index: defaultIndex,
        //isVisible: value && value.length > 1
      });
    }

    handleKeyDown(e) {
      //Handle keycodes
      this.handleKeyboard(e);
    }

    handleClickOutside(e) {
      if (this.wrapperRef.current && !this.wrapperRef.current.contains(e.target)) {
        this.dispatch({
          isVisible: false
        });
      }
    }

    handleOnSelect(item) {
      this.dispatch({
        isVisible:false,
        value: item.value
      });
    }

    async fetchCategories() {
      const rawRes = await this.props.fetch(`${REACT_APP_API_BASE}/units/search/categories`);

      if (rawRes.ok) {
        return await rawRes.json();
      }

      return null;
    }

    async handleFocus(e) {
      const value = e.target.value;
      if (this.state.hits.length === 0) {
        this.setState({
          isVisible: true
        });
      }  

      if (value) {
        this.handleChange(e, true);
      }
      
      if (!this.state.categories) {
        const categories = await this.fetchCategories();
      
        this.setState({
          categories,
          isLoadingCategories: false
        });
      }
      
      

      /*const value = e.target.value;
      if(value) {
        autoComplete(`${autoCompletePath}?q=${e.target.value}`)((action) => {
          this.dispatch({
            ...action,
            currentIndexObject: this.hasHits(action.payload) ? summaryHits(action.payload)[defaultIndex] : null,
          });
        }, this.getState.bind(this));

        this.clear(value);
      }*/
    }

    async componentDidMount() {
        document.addEventListener('click', this.boundHandleClickOutside);
        document.addEventListener('focus', this.boundHandleClickOutside, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.boundHandleClickOutside);
        document.removeEventListener('focus', this.boundHandleClickOutside, true);
    }

    render() {
      return (
        <div className="search-bar" ref={this.wrapperRef}>
          <WrappedComponent {...this.props}
            handleChange={this.handleChange.bind(this)}
            handleKeyDown={this.handleKeyDown.bind(this)}
            handleOnSelect={this.handleOnSelect.bind(this)}
            handleFocus={this.handleFocus.bind(this)}
            suggestions={this.state}  />
        </div>
      );
    }
  }

  return withFetch(Container);

};

export default Container;
